export const agentRoles = [{
  label: "Agent",
  value: "AGENT"
}]